import { Divider, Typography } from "@/components/atoms";
import { StripeState } from "@/redux/slices/payment/types";
import { clsx } from "@/utils";
import { renderDetail } from "../helpers";

interface DepositsDetailsProps extends React.HTMLAttributes<HTMLDivElement> {
  deposits: StripeState["deposits"];
}

export const DepositsDetails = ({ deposits, className, ...props }: DepositsDetailsProps) => {
  return (
    <div
      className={clsx("flex flex-col rounded-lg border border-neutral-mid-gray bg-neutral-surface-gray p-5 lg:w-[573px]", className)}
      {...props}
    >
      <Typography variant="action" className="text-neutral-dark-gray">
        Bank Name
      </Typography>
      <Typography variant="title" className="mt-1">
        {renderDetail(deposits.bankName)}
      </Typography>
      <Divider className="my-3" />
      <div className="grid grid-cols-2">
        <div className="col-span-1">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Bank State Branch
          </Typography>
          <Typography variant="paragraph">{renderDetail(deposits.routingNumber)}</Typography>
        </div>
        <div className="col-span-1">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Last 4 digits of account number
          </Typography>
          <Typography variant="paragraph">{renderDetail(deposits.accountNumber)}</Typography>
        </div>
      </div>
    </div>
  );
};
